import Vue from 'vue';
import Vuex from 'vuex';
import { camelCase } from 'lodash';

Vue.use(Vuex);

const modulesResolve = require.context('./modules', false, /\.js$/);
const modules = modulesResolve.keys().reduce((acc, filePath) => {
  const pathParts = filePath.split('/');
  const name = pathParts[pathParts.length - 1].replace(/\.js$/, '');
  return {
    ...acc,
    [camelCase(name)]: modulesResolve(filePath).default,
  };
}, {});

export default new Vuex.Store({
  modules,
});
